import { data, useNavigate } from 'react-router'
import AlianzasSection from '#app/components/alianzas-section.tsx'
import CtaSection from '#app/components/cta-section.tsx'
import Footer from '#app/components/footer.tsx'
import { HeroCarousel } from '#app/components/hero-carousel.tsx'
import { InsuranceSection } from '#app/components/insurance-section.tsx'
import ProjectsSection from '#app/components/projects-section.tsx'
import TeamSection from '#app/components/team-section.tsx'
import TestimonialsSection from '#app/components/testimonials-section.tsx'
import VideoSection from '#app/components/video-section.tsx'
import {
	ContactoAliadosSchema,
	sendContactoAliadosEmail,
} from '#app/utils/email.server.ts'
import { type Route } from './+types/index.ts'
import { slides } from './config.ts'
import { insuranceTabs } from './insurance-config.ts'

export const meta: Route.MetaFunction = () => [
	{ title: '100prevalor - Avanza hacia un futuro seguro' },
	{
		name: 'description',
		content: 'Sostenibilidad y valor para un futuro mejor',
	},
]

export async function action({ request }: Route.ActionArgs) {
	const formData = await request.formData()

	const formDataObject = Object.fromEntries(formData)

	// Validar datos con Zod schema
	const validation = ContactoAliadosSchema.safeParse(formDataObject)

	if (!validation.success) {
		const errors: Record<string, string[]> = {}

		validation.error.errors.forEach((error) => {
			const field = error.path[0] as string
			if (!errors[field]) {
				errors[field] = []
			}
			errors[field].push(error.message)
		})

		return data({ success: false, errors })
	}

	try {
		// Enviar email usando el servicio
		await sendContactoAliadosEmail(validation.data)

		return data({
			success: true,
			message:
				'¡Gracias por tu interés! Hemos recibido tu información y te contactaremos pronto para explorar oportunidades de colaboración.',
		})
	} catch (error) {
		console.error('Error enviando formulario de aliados:', error)
		return data({
			success: false,
			message:
				'Ocurrió un error al enviar el formulario. Por favor intenta nuevamente o contactanos directamente.',
		})
	}
}

export default function Index() {
	const navigate = useNavigate()

	const handleInsuranceClick = (insuranceLink: string | undefined) => {
		if (insuranceLink) {
			void navigate(insuranceLink)
		} else {
			console.log('Insurance clicked:', insuranceLink)
			// TODO: Implement navigation for other insurance types
		}
	}
	return (
		<main className="font-parkinsans">
			{/* Hero Section */}
			<HeroCarousel slides={slides} />

			{/* Insurance Section */}
			<InsuranceSection
				tabs={insuranceTabs}
				onInsuranceClick={handleInsuranceClick}
			/>

			{/* Video/Environmental Section */}
			<VideoSection />

			{/* Projects Section */}
			<ProjectsSection />

			{/* Alianzas Section */}
			<AlianzasSection className="inline-flex flex-col items-center justify-start gap-2.5 self-stretch overflow-hidden bg-gradient-to-br from-blue-500 to-green-500 py-24" />

			{/* Team Section */}
			<TeamSection />

			{/* Testimonials Section */}
			<TestimonialsSection />
			{/* CTA Newsletter Section */}
			<CtaSection />

			{/* Footer */}
			<Footer />
		</main>
	)
}
